import React from 'react';
import { Link } from 'react-scroll';
import '../assets/styles/Hero.css';

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-overlay"></div>
      <div className="container hero-container">
        <div className="hero-content">
          <h1>Engineering Services</h1>
          <p>Provide quality engineering services to projects</p>
          <ul className="hero-list">
            <li>With integrity</li>
            <li>Detail orientation from a mature perspective</li>
            <li>Time and budget conscious</li>
          </ul>
          <div className="hero-buttons">
            <Link to="services" smooth={true} duration={500} className="btn">Our Services</Link>
            <Link to="contact" smooth={true} duration={500} className="btn btn-outline">Contact Us</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;